import React from 'react';


export const SecurityStandardContext = React.createContext({
  selectedVariant: null,
  securityStandard: null,
  guidelinesViewState : {}
});

